import * as XLSX from "xlsx";

type Column = { label: string; value: string | ((row: any) => any) };

export function exportToExcel(
  data: any[],
  columns: Column[],
  sheetName: string,
  filename: string
) {
  const rows = data.map((row) => {
    const obj: Record<string, any> = {};
    columns.forEach((col) => {
      obj[col.label] =
        typeof col.value === "function" ? col.value(row) : row[col.value];
    });
    return obj;
  });
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, `${filename}.xlsx`);
}
